import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  const theme = useTheme();

  return (
    <Box 
    sx={{
      marginTop: {
        xs: '0px',
        sm: '0px',
        md: '-10px'
      },
      marginLeft: {
        xs: '-5px',
        sm: '-10px',
        md: '-10px'
      }
    }}>
      <div className="THE-MINERS-SUPPLY-CO-1-outer">
        <div
          id="THE-MINERS-SUPPLY-CO-1"
          data-name="THE MINERS SUPPLY CO."
          className="THE-MINERS-SUPPLY-CO-1"
          
        >
          <Box
            key="0"
            className="logo-text-container"
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'nowrap',
            }}
          >
            <div className="logo-1-outer">
              <img
                id="logo-1"
                data-name="logo 1"
                alt="logo 1"
                className="logo-1"
                style={{
                  height: 'auto',
                  flexShrink: 0,
                }}
              />
            </div>
            <Box
              component="span"
              className="company-name"
              sx={{
                fontSize: {
                  xs: '1.2rem',
                  sm: '1.6rem',
                  md: '1.8rem'
                },
                marginLeft: {
                  xs: '-6px',
                  sm: '10px',
                  md: '4px'
                },
                marginTop: '12px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              MINERS SUPPLY CO.
            </Box>
          </Box>       
        </div>
      </div>
    </Box>
  );
}